import { createContext, useContext } from 'react';

import type { IPermissionRule } from './role-rules';

interface TPermissionsContext {
  hasRolePermission: (rule: IPermissionRule) => boolean;
}

export const PermissionsContext = createContext({} as TPermissionsContext);

export function usePermissions() {
  const context = useContext(PermissionsContext);

  if (!context) {
    throw new Error('usePermissions missing a PermissionProvider');
  }

  return context;
}
